<template>
  <div class="panel">
    <div class="panel-heading has-background-info-light has-text-info-dark">
      Donacija
    </div>
    <div
      v-for="don in donations"
      :key="don.tag"
      class="panel-block"
    >
      <div class="column has-text-left py-0 px-0">
        <a :href="'/member/' + don.tag.substring(1)">
          {{don.name}}
        </a>
      </div>
      <div class="column has-text-right py-0 px-0">
        {{don.donations}}
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api';

export default {
  setup() {
    const apiHost = process.env.VUE_APP_API_HOST;
    const donURL = '/top/donacije';

    const donations = ref([]);

    const API_URL = apiHost;

    async function getDonations() {
      const response = await fetch(API_URL + donURL);
      const json = await response.json();
      donations.value = json;
    }

    getDonations();

    return {
      donations,
    };
  },
};
</script>

<style>
</style>
